// Lockpick puzzle configuration — tweak speeds and tolerances here
export const LOCKPICK = {
  maxPicks: 3, // lockpicks per pin before reset
  pins: [
    { speed: 160, sweetSpot: 50, tolerance: 16 },
    { speed: 200, sweetSpot: 30, tolerance: 14 },
    { speed: 250, sweetSpot: 72, tolerance: 12 },
    { speed: 300, sweetSpot: 40, tolerance: 10 },
    { speed: 360, sweetSpot: 60, tolerance: 8 },
  ],
};

export const ITEMS = {
  LAB_KEYCARD: { id: 'lab_keycard', name: 'Lab Keycard Alpha', icon: 'Key' },
  TACTICAL_SCOPE: { id: 'tactical_scope', name: 'Tactical Scope', icon: 'Crosshair' },
  VAULT_KEY: { id: 'vault_key', name: 'Vault Key', icon: 'Lock' },
  FIRST_AID_KIT: { id: 'first_aid_kit', name: 'First Aid Kit', icon: 'Heart' },
  SECURITY_BADGE: { id: 'security_badge', name: 'Security Badge', icon: 'Shield' },
  ACCESS_CHIP: { id: 'access_chip', name: 'Access Chip', icon: 'Cpu' },
  ENCRYPTED_MAP: { id: 'encrypted_map', name: 'Encrypted Map', icon: 'Map' },
  MASTER_KEY: { id: 'master_key', name: 'Master Key', icon: 'KeyRound' },
  POWER_CELL: { id: 'power_cell', name: 'Power Cell', icon: 'Zap' },
  SIGNAL_BEACON: { id: 'signal_beacon', name: 'Signal Beacon', icon: 'Radio' },
  MUSIC_BOX_KEY: { id: 'music_box_key', name: 'Music Box Key', icon: 'Music' },
};


